<div class="relative">
  <button type="button"
          class="absolute top-[7px] right-[7px] size-7 rounded-full bg-[#f5f7f7] border-none cursor-pointer flex items-center justify-center text-[#6b7d82] text-[11px] font-semibold transition-colors hover:bg-[#e8ebeb] hover:text-[#022d35]"
          (click)="matDialogRef.close()">
    <mat-icon svgIcon="close" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-[#022D35]"></mat-icon>
  </button>
  <aside class="shrink-0 bg-[#0f3d3b] flex flex-col overflow-hidden p-5 pb-4 gap-2">
    <h2 class="!m-0 text-white text-[26px] font-semibold leading-none">{{ choosePackage().name | titlecase }}</h2>
    @if(choosePackage().description){
      <p class="!m-0 text-[#a1c4c7] text-[11px] font-medium leading-[1.4]">{{ choosePackage().description }}</p>
    }
    <div class="bg-[#14423d] rounded-[10px] px-3 py-[10px] flex flex-col gap-1 w-full">
      <span class="text-[#80d9e0] text-[9px] font-bold tracking-[1px]">PER REPORT</span>
      <div class="flex items-baseline gap-1">
        <span class="text-white text-[18px] font-semibold leading-[1.1]">{{ priceRange().from }}</span>
        <span class="text-[#a1c4c7] text-[13px] font-medium">-</span>
        <span class="text-[#a1c4c7] text-[13px] font-semibold">
          {{ priceRange().to }} <span class="text-[#a1c4c7] text-[11px] font-semibold">USDT</span>
        </span>
      </div>
    </div>
    <div class="h-px w-full bg-white/10"></div>
    <p class="!m-0 text-[#a1c4c7] text-[12px] font-bold tracking-[1.2px]">WHAT'S INCLUDED</p>
    <ul class="list-none !m-0 p-0 flex flex-col gap-[10px]">
      @for (benefit of choosePackage().generalBenefits; track benefit) {
        <li class="flex items-start gap-[7px]">
          <span class="shrink-0 size-[16px] rounded-full text-white flex items-center justify-center leading-none bg-[#218c59]">
            <mat-icon svgIcon="pricing-check-mark" class="!w-full !h-auto max-w-[10px] max-h-[8px] text-inherit mt-[1px]"></mat-icon>
          </span>
          <span class="flex-1 text-[12px] font-medium leading-[1.4] text-white">{{ benefit }}</span>
        </li>
      }
      <li class="flex items-start gap-[7px]">
        <span class="shrink-0 size-[16px] rounded-full text-white flex items-center justify-center leading-none bg-[#17737d]">
          <mat-icon svgIcon="pricing-star" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-inherit"></mat-icon>
        </span>
        <span class="flex-1 text-[12px] leading-[1.4] text-[#80e5eb] font-semibold">Rates locked for 12 months</span>
      </li>
      @if (choosePackage().complianceHoursYearly) {
        <li class="flex items-start gap-[7px]">
          <span class="shrink-0 size-[16px] rounded-full text-white flex items-center justify-center leading-none bg-[#17737d]">
            <mat-icon svgIcon="pricing-star" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-inherit"></mat-icon>
          </span>
          <span class="flex-1 text-[12px] leading-[1.4] text-[#80e5eb] font-semibold">{{ choosePackage().complianceHoursYearly }} hours of compliance support / year</span>
        </li>
      }
      @for (benefit of choosePackage().yearlyBenefits; track benefit) {
        <li class="flex items-start gap-[7px]">
          <span class="shrink-0 size-[16px] rounded-full text-white flex items-center justify-center leading-none bg-[#17737d]">
            <mat-icon svgIcon="pricing-star" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-inherit"></mat-icon>
          </span>
          <span class="flex-1 text-[12px] leading-[1.4] text-[#80e5eb] font-semibold">{{ benefit }}</span>
        </li>
      }
    </ul>
  </aside>
  <div class="flex flex-col gap-[14px] w-full h-full p-5 bg-white relative">
    <header class="flex items-center justify-between w-full">
      <h2 class="!m-0 text-[18px] font-semibold text-[#022d35] leading-tight">Choose billing</h2>
    </header>
    <p class="!m-0 text-[13px] font-normal text-[#6b7d82]">{{ choosePackage().name | titlecase }} plan · same features either way</p>

    <button type="button"
            class="flex items-center justify-between gap-3 w-full rounded-[12px] text-left transition-colors"
            [ngClass]="selectedBilling() === 'monthly' ? 'border-2 border-[#17737d] bg-[#ebfaf5] py-[13px] pl-[13px] pr-[15px]' : 'border border-[#dee3e3] bg-white py-[14px] pl-[14px] pr-4'"
            (click)="selectedBilling.set('monthly')">
    <span class="flex items-center gap-3 min-w-0">
      <span class="size-[18px] shrink-0 rounded-full border-[1.5px] flex items-center justify-center"
            [ngClass]="selectedBilling() === 'monthly' ? 'border-[#17737d]' : 'border-[#c2cccc]'">
        <span class="size-2 rounded-full" [ngClass]="selectedBilling() === 'monthly' ? 'bg-[#17737d]' : 'bg-transparent'"></span>
      </span>
      <span class="flex flex-col gap-[2px] min-w-0">
        <span class="text-[15px] font-semibold text-[#022d35] leading-none">Monthly</span>
        <span class="text-[11px] font-normal text-[#6b7d82]">Flexible monthly billing</span>
      </span>
    </span>
      <span class="text-[14px] font-semibold text-[#022d35] shrink-0">{{ choosePackage().planPriceMonthly }}/mo</span>
    </button>

    <button type="button"
            class="flex items-center justify-between gap-3 w-full rounded-[12px] text-left transition-colors"
            [ngClass]="selectedBilling() === 'annual' ? 'border-2 border-[#17737d] bg-[#ebfaf5] py-[13px] pl-[13px] pr-[15px]' : 'border border-[#dee3e3] bg-white py-[14px] pl-[14px] pr-4'"
            (click)="selectedBilling.set('annual')">
    <span class="flex items-center gap-3 min-w-0">
      <span class="size-[18px] shrink-0 rounded-full border-[1.5px] flex items-center justify-center"
            [ngClass]="selectedBilling() === 'annual' ? 'border-[#17737d]' : 'border-[#c2cccc]'">
        <span class="size-2 rounded-full" [ngClass]="selectedBilling() === 'annual' ? 'bg-[#17737d]' : 'bg-transparent'"></span>
      </span>
      <span class="flex flex-col gap-[2px] min-w-0">
        <span class="flex items-center gap-[6px] flex-wrap">
          <span class="text-[15px] font-semibold text-[#022d35] leading-none">Annual</span>
          <span class="bg-[#17737d] text-white text-[8px] font-bold tracking-[0.32px] px-[6px] py-[2px] rounded-full leading-none">RECOMMENDED</span>
        </span>
        <span class="text-[11px] font-normal text-[#6b7d82]">{{ choosePackage().complianceHoursYearly }}h compliance · rate lock</span>
      </span>
    </span>
      <span class="text-[14px] font-semibold text-[#022d35] shrink-0">{{ choosePackage().planPriceYearly }}/yr</span>
    </button>

    <div class="flex flex-col gap-[6px] w-full p-[14px] rounded-[12px] bg-[#f7fafa]">
      <div class="flex items-start justify-between w-full">
        <span class="text-[12px] font-normal text-[#6b7d82]">{{ choosePackage().name | titlecase }} · {{ selectedBilling() === 'annual' ? 'Annual' : 'Monthly' }}</span>
        <span class="text-[13px] font-semibold text-[#022d35]">{{ amount() }} USDT</span>
      </div>
      <div class="h-px w-full bg-[#dee3e3]"></div>
      <div class="flex items-start justify-between w-full">
        <span class="text-[14px] font-semibold text-[#022d35]">Total due today</span>
        <span class="text-[16px] font-semibold text-[#022d35]">{{ amount() }} USDT</span>
      </div>
    </div>

    <button type="button"
            class="flex items-center justify-center gap-2 w-full py-[14px] rounded-[10px] bg-[#022d35] text-white text-[14px] font-semibold transition-colors hover:bg-[#1a8c99] active:scale-[0.98]"
            (click)="onContinue()">
      Continue to payment →
    </button>
  </div>
</div>


